import { handleActions } from 'redux-actions';

import {
  fetchKeywordEvents,
  resetKeywordEventDraft,
  updateKeywordEventDraft,
  updateKeywordEvents,
} from '../actions/keyword_events';

export default handleActions(
  {
    [fetchKeywordEvents]: (state, { payload }) => ({
      ...state,
      events: [...payload],
      isLoaded: true,
    }),
    [updateKeywordEvents]: (state, { payload: [eventToUpdate] }) => {
      const { events } = state;

      let shouldCreateEvent = true;

      events.forEach((event, index) => {
        const eventId = event._id || event.id;
        const eventToUpdateId = eventToUpdate._id || eventToUpdate.id;

        if (eventId === eventToUpdateId) {
          shouldCreateEvent = false;

          if (eventToUpdate.status === 'REMOVED') {
            events.splice(index, 1);
          } else {
            events.splice(index, 1, eventToUpdate);
          }
        }
      });

      if (shouldCreateEvent) {
        events.push(eventToUpdate);
      }

      return {
        ...state,
        events: [...events],
      };
    },
    [resetKeywordEventDraft]: (state) => ({
      ...state,
      draftEvent: null,
    }),
    [updateKeywordEventDraft]: (state, { payload }) => ({
      ...state,
      draftEvent: { ...state.draftEvent, ...payload },
    }),
  },
  {
    events: [],
    draftEvent: null,
  }
);
